import React from 'react'
import { Option } from '@elgatoylacaja/utils'

export type Punto = [number, number]

export type EVPRange =
  | 'seguro'
  | 'casi_seguro'
  | 'muy_probable'
  | 'creo_que_si'
  | 'puede_ser'
  | 'quizas'
  | 'igual_al_azar'
  | 'no_se'
  | 'lo_dudo'
  | 'dificilmente'

export type EVPRangeMoved =
  | 'seguro_moved'
  | 'casi_seguro_moved'
  | 'muy_probable_moved'
  | 'creo_que_si_moved'
  | 'puede_ser_moved'
  | 'quizas_moved'
  | 'igual_al_azar_moved'
  | 'no_se_moved'
  | 'lo_dudo_moved'
  | 'dificilmente_moved'

export type EVPKey =
  | EVPRange
  | 'seguramente'
  | 'pienso_que_si'
  | 'probable'
  | 'poco_probable'
  | 'improbable'
  | 'muy_improbable'

export type EVPMovedKey =
  | EVPRangeMoved
  | 'seguramente_moved'
  | 'pienso_que_si_moved'
  | 'probable_moved'
  | 'poco_probable_moved'
  | 'improbable_moved'
  | 'muy_improbable_moved'

export type EVP = {
  id: number
  palabra: string
  key: EVPKey
  moved_key: EVPMovedKey
  puntos?: boolean
  frase?: React.ReactChild
  askRange?: boolean
}

export const EVPs: EVP[] = [
  {
    id: 1,
    palabra: 'Seguro',
    key: 'seguro',
    moved_key: 'seguro_moved',
    askRange: true,
    puntos: true,
    frase: (
      <>
        <b>Seguro</b> la respuesta es correcta.
      </>
    ),
  },
  {
    id: 2,
    palabra: 'Casi seguro',
    key: 'casi_seguro',
    moved_key: 'casi_seguro_moved',
    askRange: true,
    puntos: true,
    frase: (
      <>
        <b>Casi seguro</b> la respuesta es correcta.
      </>
    ),
  },
  {
    id: 3,
    palabra: 'Seguramente',
    key: 'seguramente',
    moved_key: 'seguramente_moved',
  },
  {
    id: 4,
    palabra: 'Muy probable',
    key: 'muy_probable',
    moved_key: 'muy_probable_moved',
    puntos: true,
    askRange: true,
    frase: (
      <>
        <b>Muy probable</b> que la respuesta sea correcta.
      </>
    ),
  },
  {
    id: 5,
    palabra: 'Pienso que sí',
    key: 'pienso_que_si',
    moved_key: 'pienso_que_si_moved',
  },
  {
    id: 6,
    palabra: 'Creo que sí',
    key: 'creo_que_si',
    moved_key: 'creo_que_si_moved',
    askRange: true,
    puntos: true,
    frase: (
      <>
        <b>Creo que</b> la respuesta es correcta.
      </>
    ),
  },
  {
    id: 7,
    palabra: 'Probable',
    key: 'probable',
    moved_key: 'probable_moved',
  },
  {
    id: 8,
    palabra: 'Puede ser',
    key: 'puede_ser',
    moved_key: 'puede_ser_moved',
    askRange: true,
    puntos: true,
    frase: (
      <>
        <b>Puede ser</b> que la respuesta sea correcta.
      </>
    ),
  },
  {
    id: 9,
    palabra: 'Quizás',
    key: 'quizas',
    moved_key: 'quizas_moved',
    askRange: true,
    puntos: true,
    frase: (
      <>
        <b>Quizás</b> la respuesta es correcta.
      </>
    ),
  },
  {
    id: 10,
    palabra: 'Igual al azar',
    key: 'igual_al_azar',
    moved_key: 'igual_al_azar_moved',
    puntos: true,
    askRange: true,
    frase: (
      <>
        La probabilidad que la respuesta sea correcta es: <b>igual al azar</b>.
      </>
    ),
  },
  {
    id: 11,
    palabra: 'No sé',
    key: 'no_se',
    moved_key: 'no_se_moved',
    askRange: true,
    puntos: true,
    frase: (
      <>
        <b>No sabe</b> si la respuesta es correcta.
      </>
    ),
  },
  {
    id: 12,
    palabra: 'Lo dudo',
    key: 'lo_dudo',
    moved_key: 'lo_dudo_moved',
    askRange: true,
  },
  {
    id: 13,
    palabra: 'Poco probable',
    key: 'poco_probable',
    moved_key: 'poco_probable_moved',
  },
  {
    id: 14,
    palabra: 'Difícilmente',
    key: 'dificilmente',
    moved_key: 'dificilmente_moved',
    askRange: true,
  },
  {
    id: 15,
    palabra: 'Improbable',
    key: 'improbable',
    moved_key: 'improbable_moved',
  },
  {
    id: 16,
    palabra: 'Muy improbable',
    key: 'muy_improbable',
    moved_key: 'muy_improbable_moved',
  },
]

export const evps_juego: Array<Option<EVPKey>> = EVPs.filter(
  evp => evp.puntos
).map(evp => ({
  id: evp.id,
  label: evp.palabra,
  value: evp.key,
}))
